/**
 * Get target elements of a custom element.
 *
 * @param {HTMLElement} element
 * @returns {Record<string, HTMLElement[]>}
 * @example <div data-target="example-element.item"></div>
 * @example
 * const {
 *    item: items, // Array of items
 *    item: [item] = [] // Single item or undefined
 * } = codeGetTargets(this);
 */
function codeGetTargets(element) {

  const tagName = element.tagName.toLowerCase();

  return [...element.querySelectorAll(`[data-target^="${tagName}"]`)].reduce((acc, target) => {
    const key = target.dataset.target.replace(`${tagName}.`, '');

    return {
      ...acc,
      [key]: [...(acc[key] || []), target],
    };
  }, {});
}

// Attach to the global window object
window.codeGetTargets = codeGetTargets;
